import ArticleLiveEvent from 'components/live/articleLiveEvent';
import { merge } from 'lodash-es';
import type { ArticleHeaderFromContextProps } from '../shared/types';
import PictureWithLink from 'components/generic/picture/PictureWithLink';

export default function Image({
    image,
    liveEvent,
    ...restProps
}: {
    image: Exclude<ArticleHeaderFromContextProps['image'], undefined>;
    liveEvent?: ArticleHeaderFromContextProps['liveEvent'];
}) {
    const formattedLiveEvent: ArticleHeaderFromContextProps['liveEvent'] = merge({}, liveEvent, {
        liveEvent: {
            image: { ...image?.image }
        }
    });

    return liveEvent ? (
        <ArticleLiveEvent {...formattedLiveEvent} {...restProps} />
    ) : (
        <PictureWithLink props={image} {...restProps} />
    );
}
